import { render, staticRenderFns } from "./BPrimary.vue?vue&type=template&id=18c12172&scoped=true&"
import script from "./BPrimary.vue?vue&type=script&lang=ts&"
export * from "./BPrimary.vue?vue&type=script&lang=ts&"
import style0 from "./BPrimary.vue?vue&type=style&index=0&id=18c12172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c12172",
  null
  
)

export default component.exports